import { UserStore } from './user/user-store.state';
import { DriverStore } from './driver/user-store.state';

export const store = [
  UserStore,
  DriverStore
];
